// PREDICATES primarily used for statuspage header's menu items
export enum PREDICATES {
  MANAGE_SUBSCRIPTION = 'manage-subscription-btn',
  CANCEL_OR_REACTIVATE_ENTITLEMENT = 'cancel or reactivate entitlement',
  DELETE_PRODUCT = 'delete product data',
  CANCEL_SCHEDULED_SUBSCRIPTION = 'cancel scheduled subscription',
  OPT_OUT = 'opt out',
  SWITCH_TO_ANNUAL = 'switch to annual',
  SWITCH_TO_MONTHLY = 'switch to monthly',
  UPDATE_INVOICE_GROUP = 'update invoice group',
  REWIND_SUBSCRIPTION = 'rewind subscription',
  REBILL = 'rebill',
  CHANGE_PRICING = 'change pricing',
  ADD_PROMOTIONS = 'add promotions',
  REMOVE_PROMOTION = 'remove promotion',
  EXTEND_TRIAL = 'extend trial',
  SUBSCRIBE_TO_ADD_ONS = 'subscribe to add-ons',
  SET_BILL_DATE = 'set bill date',
  CREATE_QUOTE = 'create quote',
  TRANSFER_BILLING_ACCOUNT = 'transfer_billing_account',
}
